import { createContext } from 'react';

export const HintsContext = createContext<{
  hints: { id: string; active: number; pageHints: []; allHints: [] } | null;
  setHints: any;
}>({ hints: null, setHints: () => {} });
